module.exports = __webpack_public_path__ + "static/mevia-env2@2x-min-8daf0c89781b9291abb6e259a741913c.png";